import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { AutopilotProUpgradeButton } from 'components/AutopilotUpgradeButtons'
import { Button } from 'components/Button/Button'

export const LiveSupportUpgradeModal = () => {
  const { closeModal } = useModals()
  return (
    <Modal.Root size="sm" onPressOutside={closeModal}>
      <Modal.Header title="24/7 live support is a paid feature" />
      <Modal.Content>
        <Text variant="primary">
          Upgrade to chat with us anytime. On Free, email <a href="mailto:support@blaze.ai">support@blaze.ai</a>
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button autoFocus size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <AutopilotProUpgradeButton />
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
